// Third Party Imports
import React from 'react';

// HA Artifactory Imports
import {FormInput} from '@homeaway/react-form-components';

// Relative Imports
import ContinueButtonHolder from '../ButtonHolder/ContinueButtonHolder';
import './BasicInformation.less';

class BasicInformation extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.triggerEdapPageViewAction();
    }

    render() {
        let {
            translations,
            firstNameVal,
            firstNameError,
            handleFirstNameChange,
            lastNameVal,
            lastNameError,
            handleLastNameChange,
            emailVal,
            emailError,
            handleEmailChange,
            handleEmailBlur,
            handleFirstNameBlur,
            handleLastNameBlur,
            handleFormSubmit,
            enableContinueButton,
            triggerEdapEventOnFocus
        } = this.props;

        return (
            <div id="basic-information" className="basic-information-page">
                <div className="basic-information-container">
                    <div className="panel-head">
                        <div>
                            <h1 className="head">{translations['ipmob.basic_information.lcm.heading']}</h1>
                            <span className="basic-information-desc">{translations['ipmob.basic_information.lcm.sub_heading_1']}</span>
                        </div>

                    </div>
                    <form role="form" onSubmit={handleFormSubmit}>
                        <div className="input-container" aria-label="Big form">
                            <div className="name-content-holder">
                                <div className="content-holder input-holder">
                                    <FormInput
                                        id="firstName"
                                        type="text"
                                        name="First Name"
                                        label={translations['ipmob.create_account.label_3']}
                                        value={firstNameVal}
                                        errorMsg={translations[firstNameError]}
                                        onChange={handleFirstNameChange}
                                        maxLength="64"
                                        onFocus={triggerEdapEventOnFocus}
                                        onBlur={handleFirstNameBlur}
                                    />
                                </div>
                                <div className="content-holder input-holder">
                                    <FormInput
                                        id="lastName"
                                        type="text"
                                        name="Last Name"
                                        label={translations['ipmob.create_account.label_4']}
                                        value={lastNameVal}
                                        errorMsg={translations[lastNameError]}
                                        onChange={handleLastNameChange}
                                        maxLength="64"
                                        onFocus={triggerEdapEventOnFocus}
                                        onBlur={handleLastNameBlur}
                                    />
                                </div>
                            </div>


                            <div>
                                <div className="clearfix"/>
                                <h3 className="basic-information-email-header" >{translations['ipmob.basic_information.lcm.sub_heading_2']}</h3>
                            </div>
                            <div className="email-content-holder input-holder">
                                <FormInput
                                    id="email"
                                    className="email"
                                    type="email"
                                    name="Email Address"
                                    label={translations['ipmob.create_account.label_5']}
                                    value={emailVal}
                                    errorMsg={translations[emailError]}
                                    onChange={handleEmailChange}
                                    onBlur={handleEmailBlur}
                                    onFocus={triggerEdapEventOnFocus}
                                    maxLength="64"
                                />
                            </div>
                            <ContinueButtonHolder
                                enableContinueButton={enableContinueButton}
                                handleContinueButtonClick={handleFormSubmit}
                                translations={translations}
                                continueButtonId={'basicInformationContinueBtn'}
                            />
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

export default BasicInformation;
